/**
 * WISHLIST RENAME
 * 
 * module de gestion de renommage
 * d'une' wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { debounce } from 'throttle-debounce';
import { dialog } from "../../../../components/dialog";
const utils = require('../utils').default;

const WLRename = (() => {
    const DOM_RENAME = 'popin-wishlist-list-rename';
    const DOM_RENAME_SHOW = `[data-js-dialog-open="${DOM_RENAME}"]`;
    const DOM_RENAME_POPIN = `[data-js-dialog-id="${DOM_RENAME}"]`;
    const DOM_RENAME_FORM = `${DOM_RENAME_POPIN} form`;
    const DOM_RENAME_FIELD = `${DOM_RENAME_POPIN} .js-rename-wishlist-field`;
    const DOM_RENAME_INPUT = `${DOM_RENAME_POPIN} input`;
    const DOM_RENAME_SUBMIT = `${DOM_RENAME_POPIN} button[type="submit"]`;
    const DOM_ERROR = `${DOM_RENAME_POPIN} label[for="rename"] .error`;
    const DOM_SUCCES = `${DOM_RENAME_POPIN} label[for="rename"] .success`;

    const ERROR_LIST_NAME_TOO_LONG = 'Ce nom de liste est trop long.';
    const ERROR_LIST_NAME_EXIST = 'Ce nom de liste existe déjà.';
    const ERROR_LIST_NAME_CANNOT_RENAME_DEFAULT_LIST = 'Vous ne pouvez pas renommer la liste par défaut.';
    const SUCCESS_LIST_RENAME = 'Votre liste a bien été renommé.';

    /**
     * LIST NAME VALIDATION
     * 
     * validation du nouveau nom de WL
     * gestion de l'état disabled du btn submit
     */
    const listNameValidation = () => {
        let input = $(DOM_RENAME_INPUT);
        let listName = utils.slug(input.val());
        let error = false;
        if ($(DOM_RENAME_FORM).data('wishlist-id') === utils.slug(window.WL.getDefaultListName())) {
            error = ERROR_LIST_NAME_CANNOT_RENAME_DEFAULT_LIST;
        } else if (listName.length > 30) {
            error = ERROR_LIST_NAME_TOO_LONG;
        } else if (window.WL.isWishlistExist(listName)) {
            error = ERROR_LIST_NAME_EXIST;
        }

        if (listName.length > 1 && !error) {
            $(DOM_RENAME_SUBMIT).prop('disabled', false);
        } else {
            $(DOM_RENAME_SUBMIT).prop('disabled', true);
        }
        showNotification(error, 'ERROR');
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     * @param {event} event 
     */
    const popinOpen = (event) => {
        updateTemplates(event);
        listNameValidation();
        $(DOM_RENAME_INPUT).off().on('keyup change', debounce(250, function(event) {
            listNameValidation();
        }));
        $(DOM_RENAME_SUBMIT).off().on('click', renameList);
    };
    /**
     * RENAME LIST
     * 
     * renommage de la liste
     * @param {event} event 
     */
    const renameList = (event) => {

        event.preventDefault();
        let input = $(event.currentTarget).closest('form').find('input');
        let listNewName = input.val();
        let listOldName = $(DOM_RENAME_FORM).data('wishlist-id');
        window.WL.renameWishlist(listOldName, listNewName).then(() => {
            utils.debug('WL RENAME', {listOldName, listNewName}); 
            input.val('');
            showNotification(SUCCESS_LIST_RENAME, 'SUCCESS');
            let elem = utils.getDomListFromId(listOldName);
            let quantity = elem.find('.count').text();
            let totalPrice = elem.find('.total').text();
            utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content: SUCCESS_LIST_RENAME, type: 'success'});
            utils.dispatchCustomEvent('TRACKERS_WISHLIST_RENAME_LIST', {listNewName, quantity, totalPrice});

            dialog.close();
        }).catch((error) => {
            console.log('rename error', error);
        });
    };
    /**
     * SHOW NOTIFICATION
     * 
     * @param {string} notif 
     * @param {string} type 
     */
    const showNotification = (notif, type) => {
        // $(DOM_SUCCES).hide().children().empty();
        // $(DOM_ERROR).hide().children().empty();
        $(DOM_RENAME_FIELD).removeClass('c-form__field--error');
        $(DOM_RENAME_FIELD).find('.c-form__error').text('');
        if ('ERROR' === type && notif) {
            // $(DOM_ERROR).show().children().text(notif);
            $(DOM_RENAME_FIELD).addClass('c-form__field--error');
            $(DOM_RENAME_FIELD).find('.c-form__error').text(notif);
        } else if ('SUCCESS' === type && notif) {
            // $(DOM_SUCCES).show().children().text(notif);
        }
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     * @param {event} event 
     */
    const updateTemplates = (event) => {
        let data = {
            name: $(event.currentTarget).data('wishlist-name'),
            id: $(event.currentTarget).data('wishlist-id'),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: DOM_RENAME, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL RENAME', 'initialisation'); 
        $(DOM_RENAME_SHOW).off().on('click', popinOpen);
    }
    return {init}
})();
export default WLRename;